<template>
  <div class="people-container">
    <div class="item-background"></div>
    <div class="info-container">
      <div class="title-line">教师 <br />ACADEMIC STAFFS</div>
      <div class="teacher-line">
        <div class="teacher-box" @click="toXxl" data-name="xxl">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/xxl.jpg"
          />
          <div class="teacher-title">徐小良 Xiaoliang Xu</div>
          <div class="teacher-info">
            <div class="teacher-desc">实验室主任，教授，博导</div>
            <div class="teacher-text">
              博士(浙江大学)，NUS访问学者，杭州电子科技大学计算机软件所副所长，主要研究大数据与知识图谱、自然语言处理、类脑计算、知识表示学习
            </div>
          </div>
        </div>
        <div class="teacher-box" @click="toWyx">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/wyx.jpg"
          />
          <div class="teacher-title">王宇翔 Yuxiang Wang</div>
          <div class="teacher-info">
            <div class="teacher-desc">教授，博导</div>
            <div class="teacher-text">
              博士(东南大学)，NTU访问学者，主要研究知识图谱查询、异构网络社区查询、大数据近似查询
            </div>
          </div>
        </div>
        <div class="teacher-box" @click="toWmz">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/wmz.jpg"
          />
          <div class="teacher-title">王梦召 Mengzhao Wang</div>
          <div class="teacher-info">
            <div class="teacher-desc">特聘教授</div>
            <div class="teacher-text">
              博士(浙江大学)，主要研究基于图的矢量索引和检索算法，高维数据中的复杂查询处理
            </div>
          </div>
        </div>
      </div>
      <div class="teacher-line">
        <div class="teacher-box" @click="toFqm">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/fqm.jpeg"
          />
          <div class="teacher-title">方启明 Qiming Fang</div>
          <div class="teacher-info">
            <div class="teacher-desc">讲师</div>
            <div class="teacher-text">
              博士(清华大学)，KAUST访问学者，主要研究深度学习、类脑计算、知识图谱表示学习
            </div>
          </div>
        </div>
        <div class="teacher-box" @click="toXyx">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/xxy.jpeg"
          />
          <div class="teacher-title">夏一行 Yixing Xia</div>
          <div class="teacher-info">
            <div class="teacher-desc">讲师</div>
            <div class="teacher-text">
              博士(浙江大学)，主要研究深度学习、类脑计算、计算神经科学
            </div>
          </div>
        </div>
        
        <div class="teacher-box" @click="unknowInfo">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/wjj.jpg"
          />
          <div class="teacher-title">王晶晶 Jingjing Wang</div>
          <div class="teacher-info">
            <div class="teacher-desc">讲师</div>
            <div class="teacher-text">
              博士(香港都会大学)，主要研究智能推荐系统、深度神经网络
            </div>
          </div>
        </div>

        <div class="teacher-box" @click="toWjm">
          <img
            class="teacher-image"
            src="https://kglab-1258976754.cos.ap-shanghai.myqcloud.com/wjm.jpg"
          />
          <div class="teacher-title">王俊美 Junmei Wang</div>
          <div class="teacher-info">
            <div class="teacher-desc">讲师</div>
            <div class="teacher-text">
              博士(香港都会大学)，主要研究智能推荐系统、深度神经网络
            </div>
          </div>
        </div>
      </div>
      <div class="title-line">研发工程师<br />SOFTWARE ENGINEER</div>
      <div class="engineer-line">
        <!-- <div class="engineer-left">
          <img
            class="engineer-img"
            src="http://kglab.hdu.edu.cn/wp-content/plugins/elementor/assets/images/placeholder.png
"
            alt=""
          />
        </div> -->
        <div class="engineer-right">
          <div class="engineer-desc">
            来源，全栈开发工程师，拥有丰富的项目开发经验。多年IT从业经验，一线软件设计、研发、系统架构、DevOps经验，熟练掌握Java、vue、python等开发语言，对Web框架、数据存储、架构设计等有深入的理解和实践。
          </div>
          <div class="engineer-decoration">
            <img
              class="engineer-deco-img"
              src="http://kglab.hdu.edu.cn/wp-content/uploads/2021/09/877C3E9DB940B6368716892DF16220D5.jpg"
              alt=""
            />
            <img
              class="engineer-deco-img"
              src="http://kglab.hdu.edu.cn/wp-content/uploads/2021/09/BE18FCC22A07ED446D54256BB4542B2D.png"
              alt=""
            />
            <img
              class="engineer-deco-img"
              src="http://kglab.hdu.edu.cn/wp-content/uploads/2021/09/6483D1DDEE060D64A327BB5228387431.png"
              alt=""
            />
            <!-- <img class="engineer-deco-img" src="http://kglab.hdu.edu.cn/wp-content/uploads/2021/09/39A6FF281AE1710D170398D7E2F3340E.png" alt=""> -->
          </div>
        </div>
      </div>
      <div class="title-line">硕士研究生<br />POSTGRADUATES</div>
      <div class="postgraduates-line">
        <!-- <div class="postgraduage-box">
          <div style="margin-bottom: 8px">王梦召 Mengzhao Wang</div>
          <div>硕士研究生，2019-</div>
        </div> -->
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">曾巨凯 Jukai Zeng</div>
          <div>硕士研究生，2019-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">刘俊 Jun Liu</div>
          <div>硕士研究生，2019-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">富焘 Tao Fu</div>
          <div>硕士研究生，2019-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">王欣悦 Xinyue Wang</div>
          <div>硕士研究生，2019-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">徐宇奇 Yuqi Xu</div>
          <div>硕士研究生，2019-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">张吉锋 Jifeng Zhang</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">曾鑫俊 Xinjun Zeng</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">吴越 Yue wu</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">张明清 Mingqing Zhang</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">孙浩 Hao Sun</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">岳强 Qiang Yue</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">禹晨 Chen yu</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">吕凌威 Lingwei Lv</div>
          <div>硕士研究生，2020-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">李鹤鹏 Hepeng Li</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">苟晓璇 Xiaoxuan Gou</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">倪炯康 Jiongkang Ni</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">林哲毅 zheyi Lin</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">张思禹 Siyu Zhang</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">吴惠杰 Huijie Wu</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">吴彬 Bin Wu</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">黄拼拼 Pinpin Huang</div>
          <div>硕士研究生，2021-</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">叶舒展 Shuzhan Ye</div>
          <div>硕士研究生，2021-</div>
        </div>
      </div>
      <div class="title-line">毕业生<br />ALUMNI</div>
      <div class="postgraduates-line">
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">李畅 Chang Li</div>
          <div>硕士研究生，2018-2021，美团</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">颜海江 Hangjiang Yan</div>
          <div>硕士研究生，2018-2021，网易</div>
        </div>
        <div class="postgraduage-box">
          <div style="margin-bottom: 8px">金通学 Tongxue Jin</div>
          <div>硕士研究生，2018-2021，阿里巴巴</div>
        </div>
      </div>
      <div class="img-set"></div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  mounted() {
    document.documentElement.scrollTop = 0;
  },
  methods: {
    toXxl() {
      this.$router.push("/xuxiaoliang");
    },
    toWyx() {
      // this.$router.push("/wangyuxiang");
      window.location.href = "https://wyxlss.github.io/";
    },
    toFqm() {
      this.$router.push("/fangqiming");
    },
    toWmz() {
      window.location.href = "https://mzwang.top/";
    },
    toWjm() {
      window.location.href = "https://faculty.hdu.edu.cn/jsjxy/wjm/main.htm";
    },
    toXyx() {
      this.$router.push("/xiayixing");
    },
    unknowInfo() {
      Message("敬请期待");
    },
  },
};
</script>

<style scoped>
.people-container {
  min-height: 100vh;
}
.item-background {
  height: 60px;
}
.info-container {
  width: 80%;
  margin: 0 auto;
}
.title-line {
  margin: 32px auto;
  font-family: Microsoft YaHei;
  font-size: 40px;
  font-weight: 300;
  color: #333;
  text-align: center;
}
.teacher-line {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 32px;
}
.teacher-box {
  width: 19%;
}
.teacher-image {
  width: 100%;
}
.teacher-title {
  font-size: 20px;
  color: #03a9f4;
  text-align: center;
  font-weight: bold;
  margin-top: 12px;
  margin-bottom: 4px;
}
.teacher-info {
  font-size: 14px;
  color: #888;
}
.teacher-desc {
  text-align: center;
  margin-bottom: 8px;
}
.engineer-line {
  display: flex;
  padding: 10px;
}
.engineer-left {
  width: 34%;
}
.engineer-right {
  padding-left: 34px;
}
.engineer-img {
  width: 100%;
}
/* .engineer-decoration {
    display: flex;
    justify-content: space-evenly;
} */
.engineer-deco-img {
  margin-top: 20px;
  width: 10%;
  margin-left: 40px;
  float: right;
}
.postgraduage-box {
  width: 24%;
  color: rgb(70, 112, 127);
  font-size: 17px;
  display: inline-block;
  margin-bottom: 40px;
}
.engineer-desc {
  font-size: 16px;
}
/* .postgraduates-line {
    display: flex;
} */
@media screen and (max-width: 900px) {
  .teacher-line {
    display: block;
  }
  .teacher-box {
    width: 100%;
    text-align: center;
  }
  .teacher-image {
    width: 50%;
  }
  .engineer-line {
    display: block;
  }
  .engineer-left {
    width: 100%;
    margin-bottom: 16px;
    text-align: center;
  }
  .engineer-img {
    width: 50%;
  }
  .engineer-right {
    width: 100%;
  }
  .postgraduage-box {
    width: 48%;

    margin-bottom: 40px;
  }
  .title-line {
    margin-top: 60px;
  }
  /* .engineer-decoration {
    display: none;
} */
}
</style>


// WEBPACK FOOTER //
// src/pages/people/index.vue